import { createEntityQuery } from '../../createEntityQuery';
import { CustomerCompanyService } from '@wealthlane/api-services/wealthlane-customer-service';

const useQuery = createEntityQuery<string, void>({
  queryKey: ['getCustomerCompanyName'],
  queryFn: async () =>
    (await CustomerCompanyService.getApiCustomerApiAppCustomerCompanyCurrentCompanyName()) ?? '',
  options: { staleTime: 1000 * 60 * 30, placeholderData: '' },
});

export function useGetCompanyName(enabled = true) {
  return useQuery(undefined, { enabled });
}
